import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Helmet } from 'react-helmet-async';
import { withRouter } from '@client/shared/utils/routerUtils/routerUtils';
import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';

/*
 * Should be called when title, meta tags, etc... have to be updated according to received JSON data.
 */
class GenericHelmet extends PureComponent {
  render() {
    const { helmetData } = this.props;
    const meta = getIn(helmetData, 'meta');
    const link = getIn(helmetData, 'link');

    const metaItems = meta && meta.toJS ? meta.toJS() : meta || [];
    const linkItems = link && link.toJS ? link.toJS() : link || [];

    const titleText = getIn(helmetData, 'title') || 'Hjärt-Lungfonden';

    return (
      <Helmet>
        <title>{titleText}</title>
        {Array.isArray(metaItems) &&
          metaItems.map((attrs, index) => (
            <meta key={`meta-${index}`} {...attrs} />
          ))}
        {Array.isArray(linkItems) &&
          linkItems.map((attrs, index) => (
            <link key={`link-${index}`} {...attrs} />
          ))}
      </Helmet>
    );
  }
}

GenericHelmet.propTypes = {
  helmetData: ImmutablePropTypes.mapContains({
    title: PropTypes.string,
    meta: ImmutablePropTypes.list,
    link: ImmutablePropTypes.list,
  }),
};

export default withRouter(GenericHelmet);
